let initialState = {
	addSectionDetail: { isSectionAdded: false, name: "", description: "" },
	widgetSelectedVal: null,
	SelectedwidgetCount: [],
	modalVisible: false,
	alphaNumeric: true,
};

const addSection = (state = initialState, action) => {
	switch (action.type) {
		case "SET_ADD_SECTION_CLICKED":
			return {
				...state,
				addSectionDetail: action.payload,
			};

		case "SET_WIDGET_SELECTED_VALUE":
			return {
				...state,
				widgetSelectedVal: action.payload,
			};
		case "SET_SELECTED_WIDGET_COUNT":
			return {
				...state,
				SelectedwidgetCount: action.payload,
			};
		case "SET_MODAL_VISIBLE":
			return {
				...state,
				modalVisible: action.payload,
			};
		case "SET_ALPHA_NUMERIC":
			return {
				...state,
				alphaNumeric: action.payload,
			};

		default:
			return state;
	}
};

export default addSection;
